import { isEmpty } from 'lodash-es';
import 'bootstrap/js/dist/modal';
import AjaxLoader from '../utilities/ajax-loader';
import sweet_alert from '../utilities/sweet_alert';

export default new class ModalOptionHandler {
  openModal(select, options) {
    let modal = this.createModal(options.modalTitle, options.modalLabelName, options.editable);
    let $modal = $(modal);
    $modal.modal('show')
      .on('hidden.bs.modal', () => $modal.remove())
      .on('shown.bs.modal', () => $modal.find('#option-name').get(0).focus())
      .on('keydown', (ev) => {
        if (ev.code === 'NumpadEnter' || ev.code === 'Enter') {
          $modal.find('#save-option').trigger('click');
        }
      });
    $modal.find('form').on('submit', (ev) => ev.preventDefault());
    $modal.find('#save-option').on('click', (ev) => this.onClickSave(select, modal, options));
    $modal.find('#remove-option').on('click', (ev) => this.onClickRemove(select, modal, options));
  }

  async onClickSave(select, modal, options) {
    let $inputName = modal.querySelector('#option-name');

    if (isEmpty($inputName.value)) {
      return $inputName.closest('.form-group').classList.add('has-error');
    }

    AjaxLoader.show();
    let optionValue = await options.saveItem($inputName.value, options.itemId);
    (!!options.itemId) && $(select).find('option:selected').remove();
    let value = select[0].multiple ? [...$(select).val(), optionValue] : optionValue;
    $(select).append(new Option($inputName.value, optionValue, true, true)).val(value).trigger('select2:select');
    $(modal).modal('hide');

    setTimeout(() => AjaxLoader.hide(), 75);
  }

  async onClickRemove(select, modal, options) {
    sweet_alert.fire({
      title: 'Atenção',
      html: 'Deseja realmente remover?',
      type: 'warning',
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.value) {
        try {
          AjaxLoader.show();
          let response = await options.removeItem(options.itemId);

          if(!!response) {
            return sweet_alert.fire({
              title: 'Atenção',
              html: response.error,
              type: 'warning'
            });
          }

          $(select).find('option:selected').remove();
          $(select).val(null).trigger('select2:select');
          $(modal).modal('hide');
          setTimeout(() => AjaxLoader.hide(), 75);
        } catch (ex) {
          console.log(ex)
        }
      }
    });
  }

  createModal(title, labelName, editable) {
    let modal = $(`
      <div class="modal fade" id="modal-insert-new-option">
        <div class="modal-dialog modal-dialog-centered modal-md">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">${title}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="tr-form" role="form">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="required" for="option-name">${labelName}</label>
                      <input class="form-control name" type="text" name="option_name" id="option-name" value="${editable || ''}">
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <div class="d-flex justify-content-start align-items-center mt-3">
                <button type="button" class="btn btn-gray-primary mr-2" data-dismiss="modal">Cancelar</button>
                ${editable && '<button type="button" id="remove-option" class="btn btn-danger mr-2">Remover</button>'}
                <button type="button" id="save-option" class="btn btn-secondary">Salvar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `).get(0);

    $('body').after(modal);
    return modal;
  }
}